export default "__VITE_ASSET__62bb2126__"